import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';

export const selectFarmsData = createSelector(
  (state: RootState) => state.farms.farmsData,
  farms => farms,
);

export const selectSpatStorages = createSelector(
  (state: RootState) => state.farms.spatStorages,
  spats => spats,
);

export const selectQueueData = createSelector(
  (state: RootState) => state.farms.queueData,
  queue => queue,
);

export const selectMusselSpats = createSelector(
  (state: RootState) => state.farms.spatStorages,
  spats => spats.filter(x => x.type === 'MUSSEL'),
);
